<template>
  <div>
    <v-text-field
      outlined
      dense
      label="CEP"
      :hide-details="!error"
      :error="error"
      :error-messages="errorMessages"
      :disabled="disabled || loading"
      v-mask="'#####-###'"
      v-model="cep"
      @input="evOnCEPInput"
      @change="evOnCEPChange"
    >
    </v-text-field>
    <SearchCEP @selected="evOnSearchSelected" />
  </div>
</template>

<script>
import SearchCEP from "./SearchCEP.vue";
import apiCep from "../../services/apiCep";

export default {
  name: "VTextFieldCEP",

  components: { SearchCEP },

  props: {
    value: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
  },

  data() {
    return {
      loading: false,
      error: false,
      cep: "",
    };
  },

  created() {
    if (typeof this.value === "string") this.cep = this.value;
    else this.cep = "";
  },

  watch: {
    value() {
      if (typeof this.value === "string") this.cep = this.value;
      else this.cep = "";
      this.retrieve(false);
    },
  },

  computed: {
    errorMessages() {
      return this.error ? ["CEP Inválido"] : [];
    },
  },

  methods: {
    async evOnCEPInput(value) {
      this.$emit("input", value);
    },

    async evOnCEPChange(value) {
      this.$emit("change", value);
      this.retrieve();
    },

    retrieve(emit = true) {
      if (this.cep.length === 0) {
        this.error = false;
        return;
      }

      if (!this.cep.match(/^\d{5}-\d{3}$/)) {
        this.error = true;
        return;
      }

      this.loading = true;
      apiCep
        .get(`/${this.cep}/json`)
        .then((response) => {
          /**
           * @type {{
           *   error: boolean,
           *   cep: string,
           *   logradouro: string,
           *   complemento: string,
           *   bairro: string,
           *   localidade: string,
           *   uf string,
           *   ibge: string,
           *   gia: string,
           *   ddd: string,
           *   siafi: string,
           * }}
           *
           */
          const data = response.data;
          const { erro, cep, logradouro, complemento, bairro, localidade, uf } =
            data;

          if (erro) {
            this.error = true;
          } else {
            this.error = false;

            if (emit) {
              this.$emit("retrieved", {
                cep,
                logradouro,
                complemento,
                bairro,
                localidade,
                uf,
              });
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    evOnSearchSelected(value) {
      this.cep = value.cep;
      this.$emit("retrieved", value);
    },
  },
};
</script>

<style>
</style>
